<template>
  <GenericStep v-bind="$attrs">
    <FamilyOverviewCard class="mb-4" />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual, pick } from 'lodash'
import { mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import FamilyOverviewCard from '@/components/Party/PartyEdit/SectionCards/OverviewCards/FamilyOverviewCard.vue'
import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'

export default {
  name: 'FamilyOverviewStep',

  components: {
    FamilyOverviewCard,
    GenericStep,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return pick(
        this.peParty, [
          'num_marriages',
          'currently_married',
          'num_children',
          'mother_status',
          'father_status',
          'spouse_status',
          'child_status',
          'num_siblings',
          'usc_siblings',
          'lpr_siblings',
        ]
      )
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },
}
</script>
